/* Lavender Farm Simulator — tool belt polish (Lavender Field, Farm Map, Greenhouse, Flower Farm, Apiary).
   1. Left / right arrows on every tool belt, shown only when the tools don't all fit (phones, narrow windows).
   2. Swipe sideways on the belt scrolls it; drag a tool down onto a plot/tile/bay/bed/hive to use it (mouse + touch).
   3. Apiary gets the same belt: drag a hive tool onto a hive card, or tap a tool then tap a hive.
   Day/night colors live in gllf-sim-toolbar.css. Clicks go through the game's own buttons; never edits the save. */
(function () {
  'use strict';
  if (window.__gllfSimToolbar) return;
  window.__gllfSimToolbar = true;
  /* stylesheet sits next to this file in the theme assets */
  (function () {
    var src = (document.currentScript && document.currentScript.src) || '';
    if (!src || document.getElementById('gllf-sim-toolbar-css') || document.querySelector('link[href*="gllf-sim-toolbar.css"]')) return;
    var l = document.createElement('link'); l.id = 'gllf-sim-toolbar-css'; l.rel = 'stylesheet';
    l.href = src.replace(/gllf-sim-toolbar\.js/, 'gllf-sim-toolbar.css');
    document.head.appendChild(l);
  })();

  /* ---------- arrows ---------- */
  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gllf-belt__arrow gllf-belt__arrow--' + dir;
    b.setAttribute('data-belt-arrow', dir);
    b.setAttribute('aria-label', dir === 'prev' ? 'Scroll tools left' : 'Scroll tools right');
    b.innerHTML = '<span aria-hidden="true">' + (dir === 'prev' ? '‹' : '›') + '</span>';
    return b;
  }
  function updateRail(rail) {
    var tools = rail.querySelector('.gllf-belt__tools'); if (!tools) return;
    var max = tools.scrollWidth - tools.clientWidth;
    var scroll = max > 4;
    rail.classList.toggle('gllf-rail--scroll', scroll);
    var p = rail.querySelector('[data-belt-arrow="prev"]'), n = rail.querySelector('[data-belt-arrow="next"]');
    var pd = !scroll || tools.scrollLeft <= 2, nd = !scroll || tools.scrollLeft >= max - 2;
    if (p && p.disabled !== pd) p.disabled = pd;   /* write only on change, so the page's watchers stay quiet */
    if (n && n.disabled !== nd) n.disabled = nd;
  }
  var ro = window.ResizeObserver ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) { var r = e.target.closest('.gllf-belt__rail'); if (r) updateRail(r); });
  }) : null;
  function railify(belt) {
    var tools = belt.querySelector('.gllf-belt__tools'); if (!tools) return;
    var rail = tools.parentElement;
    if (!rail.classList.contains('gllf-belt__rail')) {
      rail = document.createElement('div');
      rail.className = 'gllf-belt__rail';
      tools.parentElement.insertBefore(rail, tools);
      rail.appendChild(arrow('prev')); rail.appendChild(tools); rail.appendChild(arrow('next'));
    }
    if (!tools.__gllfRail) {
      tools.__gllfRail = true;
      tools.addEventListener('scroll', function () { updateRail(rail); }, { passive: true });
      if (ro) ro.observe(tools);
    }
    updateRail(rail);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-belt-arrow]'); if (!a) return;
    e.preventDefault(); e.stopPropagation();
    var tools = a.parentElement.querySelector('.gllf-belt__tools'); if (!tools) return;
    var step = Math.max(120, tools.clientWidth * 0.7) * (a.getAttribute('data-belt-arrow') === 'prev' ? -1 : 1);
    tools.scrollBy({ left: step, behavior: 'smooth' });
    setTimeout(function () { updateRail(a.parentElement); }, 400);
  }, true);

  /* ---------- Apiary belt ---------- */
  var HIVE_TOOLS = [
    ['inspect', '🔎', 'Inspect'], ['monitor', '🔬', 'Sample Varroa'], ['feed', '🍯', 'Feed'],
    ['super', '📦', 'Honey super'], ['ipm', '🛡️', 'IPM action'], ['split', '✂️', 'Split'], ['requeen', '👑', 'Requeen']
  ];
  var armed = '';
  function hiveCard(x, y) { var n = document.elementFromPoint(x, y); return n && n.closest ? n.closest('[data-apiary-hive-card]') : null; }
  function say(belt, msg) {
    var s = belt.querySelector('[data-belt-say]'); if (!s) return;
    s.textContent = msg; s.hidden = !msg;
    clearTimeout(s.__t); if (msg) s.__t = setTimeout(function () { s.hidden = true; }, 3500);
  }
  function useOn(belt, id, card) {
    var btn = card.querySelector('[data-apiary-action="' + id + '"]');
    var name = (HIVE_TOOLS.filter(function (t) { return t[0] === id; })[0] || [0, 0, id])[2];
    if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.disabled) {
      card.classList.add('gta-no'); setTimeout(function () { card.classList.remove('gta-no'); }, 700);
      /* pass on the game's own reason when the card shows one (e.g. the 55°F / wind limit for colony work) */
      var why = ((card.innerText || '').match(/[^.\n]*\bneeds?\b[^.\n]*\./i) || [''])[0].replace(/^[^A-Za-z]+/, '').trim();
      say(belt, name + ' isn’t available for this hive right now.' + (why ? ' ' + why : ''));
      return;
    }
    card.classList.add('gta-done'); setTimeout(function () { card.classList.remove('gta-done'); }, 700);
    say(belt, '');
    btn.click();
  }
  function syncApiary(belt) {
    belt.querySelectorAll('[data-hive-tool]').forEach(function (b) {
      var on = b.getAttribute('data-hive-tool') === armed;
      b.classList.toggle('is-on', on); if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function apiaryBelt(view) {
    var first = view.querySelector('[data-apiary-hive-card]'); if (!first) return;
    var grid = first.parentElement;
    var belt = view.querySelector('.gllf-belt--apiary');
    if (belt && belt.nextElementSibling === grid) return;
    if (!belt) {
      belt = document.createElement('div');
      belt.className = 'gllf-belt gllf-belt--apiary';
      belt.setAttribute('role', 'toolbar');
      belt.setAttribute('aria-label', 'Apiary tools. Drag a tool onto a hive, or pick a tool and tap a hive.');
      belt.innerHTML = '<span class="gllf-belt__label" aria-hidden="true">Tools</span><div class="gllf-belt__tools">' +
        HIVE_TOOLS.map(function (t) {
          return '<button type="button" class="gllf-belt__tool" aria-pressed="false" data-hive-tool="' + t[0] + '" title="' + t[2] + ' — drag onto a hive or tap then tap a hive"><span class="gllf-belt__icon" aria-hidden="true">' + t[1] + '</span><span class="gllf-belt__name">' + t[2] + '</span></button>';
        }).join('') + '</div><p class="gllf-belt__say" data-belt-say role="status" hidden></p>';
      wireApiary(view, belt);
    }
    grid.parentElement.insertBefore(belt, grid);
    syncApiary(belt);
  }
  function wireApiary(view, belt) {
    belt.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hive-tool]'); if (!b) return;
      var id = b.getAttribute('data-hive-tool');
      armed = armed === id ? '' : id;
      syncApiary(belt);
      var nm = (b.querySelector('.gllf-belt__name') || b).textContent.trim();
      say(belt, armed ? 'Now tap a hive to use ' + nm + '.' : '');
    });
    /* tap mode: a tool is picked, tap anywhere on a hive card that isn't one of its own buttons */
    view.addEventListener('click', function (e) {
      if (!armed) return;
      var card = e.target.closest('[data-apiary-hive-card]'); if (!card) return;
      if (e.target.closest('button, a, input, select, textarea, label, summary')) return;
      e.preventDefault(); useOn(belt, armed, card);
    });
    var drag = null;
    belt.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('[data-hive-tool]'); if (!b || e.button > 0) return;
      drag = { id: b.getAttribute('data-hive-tool'), x: e.clientX, y: e.clientY, src: b };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (!drag.moved && Math.hypot(e.clientX - drag.x, e.clientY - drag.y) < 8) return;
      if (!drag.moved) {
        drag.moved = true;
        drag.ghost = document.createElement('div'); drag.ghost.className = 'gllf-belt__ghost';
        drag.ghost.textContent = drag.src.querySelector('.gllf-belt__icon').textContent;
        document.body.appendChild(drag.ghost); view.classList.add('gta-dragging');
      }
      e.preventDefault();
      drag.ghost.style.transform = 'translate(' + (e.clientX - 22) + 'px,' + (e.clientY - 22) + 'px)';
      var c = hiveCard(e.clientX, e.clientY);
      if (c !== drag.over) { if (drag.over) drag.over.classList.remove('gta-over'); if (c) c.classList.add('gta-over'); drag.over = c; }
    }, { passive: false });
    function end(e) {
      if (!drag) return; var d = drag; drag = null;
      view.classList.remove('gta-dragging'); if (d.ghost) d.ghost.remove(); if (d.over) d.over.classList.remove('gta-over');
      if (!d.moved || !e || e.type !== 'pointerup') return;
      var c = hiveCard(e.clientX, e.clientY); if (c) useOn(belt, d.id, c);
    }
    window.addEventListener('pointerup', end); window.addEventListener('pointercancel', end);
  }

  /* ---------- boot (throttled: the game mutates its DOM many times a second) ---------- */
  function tick(root) {
    var ap = root.querySelector('section.lfg-view[data-view="apiary"]');
    if (ap) apiaryBelt(ap);
    root.querySelectorAll('.gllf-belt').forEach(railify);
  }
  var tries = 0;
  (function wait() {
    var root = document.getElementById('lfg-simulator-root');
    if (!root && document.readyState === 'complete') return;
    if (root && root._lfg) {
      tick(root);
      var last = 0, timer = 0;
      function run() { timer = 0; last = Date.now(); tick(root); }
      new MutationObserver(function () {
        if (timer) return;
        var wait = Math.max(0, 150 - (Date.now() - last));
        timer = setTimeout(run, wait);
      }).observe(root, { childList: true, subtree: true });
      window.addEventListener('resize', function () { root.querySelectorAll('.gllf-belt__rail').forEach(updateRail); });
      return;
    }
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
